var render, staticRenderFns
import script from "./IndustryEventShapeMobile.vue?vue&type=script&lang=js&"
export * from "./IndustryEventShapeMobile.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./IndustryEventShapeMobile.vue?vue&type=style&index=0&id=43917cc2&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "43917cc2",
  null
  ,true
)

export default component.exports